<template>
	<div>
		<commonHeader />
		<div class="main_1" v-if="nowWidth > 784">
			<v-img src="/image/main_1.png" class="px-pc">
				<!-- <v-layout class="home-detail-btn-layout" justify-center>
					<v-btn color="#66DCFF" class="home-detail-btn" @click="$router.push({ name: 'about' })">
						자세히 보기
					</v-btn>
				</v-layout> -->
				<v-layout>
					<v-layout class="tab-css-2">
						<v-flex v-for="(tab, i) in $store.state.tabList" :key="i" class="pr-8" style="flex: 1; max-width: 20%;">
							<v-flex xs12>
								<v-divider dark class="main-hr-1 mb-3"></v-divider>
							</v-flex>
							<div>
								<div class="number mr-2">0{{ i + 1 }}</div>
								<div class="Title" @click="titleGoto(tab.link)">
									{{ tab.title }}
								</div>
							</div>
						</v-flex>
					</v-layout>
				</v-layout>
			</v-img>
		</div>
		<div v-else class="m_main_1" @click="$router.push({ name: 'about' })">
			<v-img width="100%" src="/image/m_home.png"></v-img>
			<!-- <v-layout align-center justify-center style="height:600px;">
				<v-btn color="white" class="home-detail-btn" @click="$router.push({ name: 'about' })">
					자세히 보기
				</v-btn>
			</v-layout> -->
		</div>
		<commonFooter />
	</div>
</template>
<script>
import { commonHeader, commonFooter } from '@/components/index'
export default {
	components: {
		commonHeader,
		commonFooter,
	},
	data() {
		return {
			screenWidth: window.innerWidth,
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		titleGoto(link) {
			this.$router.push({ name: link })
		},
	},
}
</script>
